import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {AuthContext} from "../../config/AuthContext";
import {useNavigate, useParams} from "react-router-dom";
import {Button, Card, Table, Tag, Tabs, Popconfirm } from "antd";
import {QuestionCircleOutlined} from "@ant-design/icons";
import Colors from "../../styles/Colors";
import {BiPencil, BiPlus, BiRefresh, BiTrash, BiWorld,BiDuplicate } from "react-icons/bi";
import {ColumnsType, TableProps} from "antd/es/table";
import RebutFIltre from "../../model/multilleure/rebuts/RebutFIltre";
import LlocTreball from "../../model/root/LlocTreball";
import {GetLlocTreball} from "../../dao/root/GetLlocTreball";
import LlocDeTreballAdminModal from "../admin/components/LlocDetreballAdminModal";
import Login from "../root/Login";
import {PostLlocTreball} from "../../dao/root/PostLlocTreball";
import {GetEmpresas} from '../../dao/admin/GetEmpresas';
import toast, {Toaster} from "react-hot-toast";
import DuplicarLlocModal from './components/DuplicarLlocModal';
const { TabPane } = Tabs;

const ControlHorarisAdmin = () => {
    const titol: string = "Llocs Treball";
    const nomPermis: string = "Control Horari";

    const {isLoggedIn, userId, user, page} = useContext(AuthContext);
    const navigate = useNavigate();
    const {id} = useParams();

    const [options, setOptions] = useState<{ label: string; value: string; }[]>([{
        label: "",
        value: ""
    }]);

    const [coleccio, setDades] = useState<LlocTreball[]>([]);
    const [llocSelected, setLlocSelected] = useState<LlocTreball>(new LlocTreball());
    const [loading, setLoading] = useState(false);
    const [visible, setVisible] = useState(true);
    const [nomFiltres, setNomFiltres] = useState<{ text: string; value: string }[]>([]);
    const [tipusFiltres, setTipusFiltres] = useState<{ text: string; value: string }[]>([]);
    const [nouLloc, setNouLloc] = useState(false);
    const permisosEdicio = user.pagines.some(pagina => pagina.descripcio === nomPermis && pagina.tipus === 1);
    const [empresas, setDadesEmpresa] = useState<any[]>([]);
    const [update, setUpdate] = useState(false);
    const [duplicarLloc, setDuplicarLloc] = useState(false);

    const [filtres, setFiltres] = useState<RebutFIltre>(new RebutFIltre());
    const typeColors: { [key: string]: string } = {
        'artiesport.ambittec.com': 'cyan',
        'mentsinquietes.ambittec.com': 'lime',
        'ambitescola.ambittec.com': 'pink',
    };

    useEffect(() => {
        if(isLoggedIn){
            handleLoadingChange(true)
            checkDades();
        }
    }, [id]);

    async function checkDades() {
        handleLoadingChange(true)
         // Obtener empresas
        const dadesEmpresas = await GetEmpresas(1, page); // TO-DO: Cambiar por id_parent
        setDadesEmpresa(dadesEmpresas);
        
        const llocstreballTotals: any[] = [];

        for (const empresa of dadesEmpresas) {
            const datasource = empresa.datasource; 
            try {
                const dades = await GetLlocTreball(datasource);
                const llocstreballEmpresa = (dades as any[]).map((lloc: any) => ({
                    ...lloc,
                    empresa: datasource
                }));
                llocstreballTotals.push(...llocstreballEmpresa);
            } catch (error) {
                console.error(`Error obteniendo datos de la empresa ${datasource}`, error);
            }
        }
        setDades(llocstreballTotals);
        await handleLoadingChange(false);
    }

    function toggleTable() {
        setVisible(!visible);
    }

    function togleNouElement(element: LlocTreball) {
        setUpdate(true);
        setLlocSelected(element);
        setNouLloc(true);
    }

    const handleLoadingChange = (enable: boolean) => {
        setLoading(enable);
    };
    function togleDuplicarLloc(element: LlocTreball, edit: boolean) {
        setDuplicarLloc(!duplicarLloc);
        setUpdate(edit);
        setLlocSelected(element);
    }
    const columns: ColumnsType<LlocTreball> = [
        {
            key: 'id',
            title: 'ID',
            dataIndex: 'id',
            width: 15,
            //responsive: ['lg'],
            sorter: (a, b) => a.id - b.id,
            sortOrder: "descend"
        },
        {
            key: 'nom',
            title: 'Nom',
            dataIndex: 'nom',
            width: 30,
            filterSearch: true,
            filters: nomFiltres,
            onFilter: (value, record) => (typeof value === 'string' ? record.nom.startsWith(value) : false),
            render: (estat, ele) =>(
                (ele.nom === 'Itinerant' && <Tag color={Colors.colors.color4}>{ele.nom}</Tag>) || (ele.nom !== 'Itinerant' && ele.nom)
            )
        },
        {
            key: 'longitud',
            title: 'Longitud',
            dataIndex: 'longitud',
            width: 30,
            render: (estat, ele) => (
                <Tag color={Colors.colors.color1}>{ele.longitud}</Tag>
            )
        },
        {
            key: 'latitud',
            title: 'Latitud',
            dataIndex: 'latitud',
            width: 30,
            render: (estat, ele) => (
                <Tag color={Colors.colors.color2}>{ele.latitud}</Tag>
            )
        },
        {
            key: 'empresa',
            title: 'Empresa',
            dataIndex: 'empresa',
            width: '15%',
            render: (name: string) => (
                <Tag color={typeColors[name]}>
                    {name}
                </Tag>
            ),
                  
        },
        {
            key: 'accions', title: 'Accions', dataIndex: 'accions', width: 30,
            render: (estat, ele) => (
                <>
                    {permisosEdicio && (
                        <>
                            <Button title={"Modificar"} style={{backgroundColor: Colors.colors.color6}}
                                    onClick={() => togleNouElement(ele)}><BiPencil/></Button>
                            
                            {" "}
                            <Popconfirm
                                title="Eliminant"
                                description="Vols eliminar definitivament aquest element?"
                                onConfirm={() => deleteLloc(ele)}
                                icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                            >
                                <Button title={"Eliminar"} style={{backgroundColor: Colors.colors.color5}}><BiTrash/></Button>
                            </Popconfirm>  
                            {" "}
                            <Button title={"Duplicar"} style={{backgroundColor: Colors.colors.color3}}
                                onClick={() => togleDuplicarLloc(ele, true)}><BiDuplicate  /></Button>
                            {" "}
                        </>
                    )}
                </>
            ),
        },
    ];

    const tableProps: TableProps<LlocTreball> = {
        loading
    };
    const onChange: TableProps<LlocTreball>['onChange'] =
        (pagination,
         filters,
         sorter,
         extra) => {
            console.log('params', pagination, filters, sorter, extra);
        };


    function afegirLloc(llocTreball: LlocTreball) {
        setUpdate(false);
        setLlocSelected(llocTreball);
        setNouLloc(true);
    }

    function handleCloseModal(value: boolean) {
         if (value){
            toast.success("GUARDAT");
            checkDades();
        }
        else
            toast.error("NO GUARDAT");
        setNouLloc(false);
        setDuplicarLloc(false);
        
    }

    async function deleteLloc(element: LlocTreball) {
        const modified: LlocTreball = {
            ...element,
            estat: -1
        };
        PostLlocTreball(modified, element.empresa);
        checkDades();
    }

    const redirigirANuevaPestana = () => {
        window.open('https://www.coordenadas-gps.com/', '_blank');
    };

    if (isLoggedIn) {
        return (
            <>
             <Toaster/>
                <Card bordered={true} className={"elemento"}>
                    <div className={"actionButtons"}>
                        {permisosEdicio &&
                            <>
                                <Button title={"Nou Lloc"} style={{backgroundColor: Colors.colors.color2}}
                                        onClick={() =>
                                            afegirLloc(new LlocTreball())}><BiPlus/></Button>
                            </>
                        }
                        <Button title={"Buscar latitud i longitud"} style={{backgroundColor: Colors.colors.color4}}
                                onClick={redirigirANuevaPestana}><BiWorld/></Button>
                        <Button title={"Refrescar"} style={{backgroundColor: Colors.colors.color5}} onClick={() =>
                            checkDades()}><BiRefresh/></Button>
                    </div>
                    <h4 className={"titol"} onClick={toggleTable}>{"Llocs de treball"}</h4>
                    {visible && (
                        <Tabs defaultActiveKey="tots" type="card">
                            <TabPane tab="Tots" key="tots">
                                <Table
                                    {...tableProps}
                                    onChange={onChange}
                                    columns={columns}
                                    dataSource={coleccio}
                                    rowKey={(record) => `${record.empresa}-${record.id}`}
                                />
                            </TabPane>
                            {/* Tabs dinámicos por empresa */}
                            {empresas.map((empresa: any) => (
                                <TabPane tab={empresa.nomEmpresa} key={empresa.datasource}>
                                    <Table
                                    {...tableProps}
                                    onChange={onChange}
                                    columns={columns}
                                    rowKey={(record) => `${record.empresa}-${record.id}`}
                                    dataSource={coleccio.filter(lloc => lloc.empresa === empresa.datasource)}
                                    />
                                </TabPane>
                            ))}
                        </Tabs>

                    )}
                </Card>
                {nouLloc && (
                    <LlocDeTreballAdminModal element={llocSelected} onClose={handleCloseModal}
                                        visible={nouLloc} update={update}/>
                )}
                {duplicarLloc && (
                    <DuplicarLlocModal element={llocSelected} onClose={handleCloseModal} visible={duplicarLloc}/>

                )}
            </>
        );
    } else {
        return (
            <Login/>
        );
    }
};
export default ControlHorarisAdmin;
